import React from 'react';
import { View, TouchableOpacity, StyleSheet } from 'react-native';
import { Ionicons } from '@expo/vector-icons';

const CameraControls = ({ torchEnabled, onTorchToggle, onSwitchCamera, onClose, hasMultipleCameras, hasTorch }) => {
  console.log('[CameraControls] Props received:');
  console.log('[CameraControls] - hasMultipleCameras:', hasMultipleCameras);
  console.log('[CameraControls] - hasTorch:', hasTorch);
  console.log('[CameraControls] - torchEnabled:', torchEnabled);

  const renderControls = () => {
    if (hasMultipleCameras && hasTorch) {
      console.log('[CameraControls] Rendering: Multiple cameras + torch layout');
      return (
        <>
          <TouchableOpacity style={styles.controlButton} onPress={onSwitchCamera} testID="switchCameraButton">
            <Ionicons name="camera-reverse" size={24} color="#fff" />
          </TouchableOpacity>

          <TouchableOpacity
            style={[styles.controlButton, torchEnabled && styles.controlButton]}
            onPress={onTorchToggle}
            testID="torchButton"
          >
            <Ionicons name={torchEnabled ? "flash" : "flash-off"} size={24} color="#fff" />
          </TouchableOpacity>

          <TouchableOpacity style={styles.controlButton} onPress={onClose} testID="closeButton">
            <Ionicons name="close" size={24} color="#fff" />
          </TouchableOpacity>
        </>
      );
    } else if (hasMultipleCameras && !hasTorch) {
      console.log('[CameraControls] Rendering: Multiple cameras, no torch layout');
      return (
        <>
          <TouchableOpacity style={styles.controlButton} onPress={onSwitchCamera} testID="switchCameraButton">
            <Ionicons name="camera-reverse" size={24} color="#fff" />
          </TouchableOpacity>

          <View style={styles.spacer} />

          <TouchableOpacity style={styles.controlButton} onPress={onClose} testID="closeButton">
            <Ionicons name="close" size={24} color="#fff" />
          </TouchableOpacity>
        </>
      );
    } else if (!hasMultipleCameras && hasTorch) {
      console.log('[CameraControls] Rendering: Single camera + torch layout');
      return (
        <>
          <TouchableOpacity
            style={[styles.controlButton, torchEnabled && styles.controlButton]}
            onPress={onTorchToggle}
            testID="torchButton"
          >
            <Ionicons name={torchEnabled ? "flash" : "flash-off"} size={24} color="#fff" />
          </TouchableOpacity>

          <View style={styles.spacer} />

          <TouchableOpacity style={styles.controlButton} onPress={onClose} testID="closeButton">
            <Ionicons name="close" size={24} color="#fff" />
          </TouchableOpacity>
        </>
      );
    } else {
      console.log('[CameraControls] Rendering: Single camera, no torch layout (close only)');
      return (
        <>
          <View style={styles.spacer} />

          <TouchableOpacity style={styles.controlButton} onPress={onClose} testID="closeButton">
            <Ionicons name="close" size={24} color="#fff" />
          </TouchableOpacity>
        </>
      );
    }
  };

  return (
    <View style={styles.topControls}>
      {renderControls()}
    </View>
  );
};

const styles = StyleSheet.create({
  topControls: {
    position: 'absolute',
    left: 65,
    right: 65,
    top: 5,
    flexDirection: 'row',
    justifyContent: 'space-between',
    paddingHorizontal: 15,
    zIndex: 10,
    backgroundColor: 'rgba(0,0,0,0.5)',
    borderRadius: 25,
    borderWidth: 1,
    borderColor: 'rgba(255,255,255,0.3)',
  },
  controlButton: {
    justifyContent: 'center',
    alignItems: 'center',
  },
  spacer: {
    flex: 1,
  },
});

export default CameraControls;
